var klaviyo = klaviyo || [];
klaviyo.init({
    account: "M5yH5T",
    platform: "shopify",
    exclude_on_tags: "nostock, artchive"

});
klaviyo.enable("backinstock",{ 
trigger: {
    product_page_text: "Please Notify Me When This Product Is Available",
    product_page_class: "btn",
    product_page_text_align: "center",
    product_page_margin: "10px",
    replace_anchor: false
},
modal: {
    headline: "{product_name}",
    body_content: "Receive a notification when this item comes back in stock.",
    email_field_label: "Email Address",
    button_label: "Notify Me",
    subscription_success_label: "You're in! We'll let you know as soon as it's back.",
    footer_content: '',
    additional_styles: "@import url('https://fonts.googleapis.com/css?family=Helvetica+Neue');",
    drop_background_color: "#000",
    background_color: "#fff",
    text_color: "#222",
    button_text_color: "#fff",
    button_background_color: "#738280",
    close_button_color: "#ccc",
    error_background_color: "#fcd6d7",
    error_text_color: "#C72E2F",
    success_background_color: "#d3efcd",
    success_text_color: "#1B9500"
}
});